import { LocationQuery, useRouter } from 'vue-router'
import { useFilterStore } from '@/store/filter'

export interface QueryParams {
    key: string
    value: string | string[] | number | boolean | number[]
}

interface TableParams {
    list?: string;
    orderBy?: string | null;
    orderDirection?: string | null;
    perPage?: string;
}

export function useQueryState() {
    const { currentRoute, push } = useRouter()

    async function updateQueryState (parameter: string, value: string|null) {
        const query = {
            ...currentRoute.value.query,
        }

        if (value) {
            await push({
                query: {
                    ...query,
                    [parameter]: value,
                },
            })

            return
        }

        delete query[parameter]

        await push({
            query: {
                ...query,
            },
        })
    }

    async function resetQuery () {
        await push({
            query: {
            },
        })

        useFilterStore().resetFilterFieldsValues()
    }

    function extractParams(query: LocationQuery, uniqueKey: string | undefined, keysToInclude: string[], include: boolean) {
        return Object.fromEntries(
            Object.entries(query).filter(([key]) => {
                const strippedKey = uniqueKey ? key.replace(uniqueKey, '') : key

                return include ? keysToInclude.includes(strippedKey) : !keysToInclude.includes(strippedKey)
            }).map(([key, value]) => {
                if (uniqueKey) {
                    key = key.replace(uniqueKey, '')
                }

                return [key, value]
            })
        )
    }

    function getSearchParams(uniqueKey?: string) {
        const { query } = currentRoute.value

        return extractParams(query, uniqueKey, ['list', 'orderBy', 'orderDirection', 'perPage'], false)
    }

    function getTableParams(uniqueKey?: string): TableParams {
        const { query } = currentRoute.value

        return extractParams(query, uniqueKey, ['list', 'orderBy', 'orderDirection', 'perPage'], true) as TableParams
    }

    return {
        updateQueryState,
        getSearchParams,
        resetQuery,
        getTableParams,
    }
}
